<template>
  <div>
    <b-alert v-bind:variant=alertType show>{{ message }}</b-alert>
    <br>
  </div>
</template>

<script>
export default {
  props: ['message', 'alertType']
}
</script>



// WEBPACK FOOTER //
// src/components/Alert.vue